module.exports = __webpack_public_path__ + "static/17-434322e716c228ac7cd903765de01119.jpg";